import { Button, Checkbox, Container, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import LogosNotification from "utils/notification-utils";
import ProgramService from "../../../../services/programs/program-service";

interface AddLessonGroupDialogProps {
    program: any
    onClose: any,
    onRefreshData: any
};

const formInitialValue = {
    name: '',
};

const AddLessonGroupDialog: FC<AddLessonGroupDialogProps> = ({ program, onClose, onRefreshData }) => {
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    useEffect(() => {
    }, []);

    const handleFormSubmit = (values: any) => {
        setIsSubmiting(true);
        ProgramService.AddLessonGroup(program.id, values.name).then((res: any) => {
            LogosNotification.Success("Lesson Group berhasil dibuat.");
            window.location.reload();
        }).finally(() => {
            setIsSubmiting(false);
        })
    };

    return (
        <Modal isOpen={true} onClose={onClose} >
            <ModalOverlay />
            <ModalContent>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, setFieldValue }) => (
                                <Form onSubmit={handleSubmit} noValidate={true}>
                                    <ModalHeader textAlign={"center"}>Buat Group Baru</ModalHeader>
                                    <ModalBody pt={5}>

                                        <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                            <FormLabel htmlFor='name'>Nama Group Baru</FormLabel>
                                            <Field
                                                as={Input}
                                                id='name'
                                                placeholder='Nama Group Lesson'
                                                name={'name'}
                                                validate={(value: any) => {
                                                    let error;
                                                    if (value.length <= 0)
                                                        error = "Nama Group wajib diisi.";
                                                    return error;
                                                }}
                                            />
                                            <FormErrorMessage>{errors.name}</FormErrorMessage>
                                        </FormControl>

                                    </ModalBody>
                                    <ModalFooter>
                                        <Button variant={'outline'} mr={3} onClick={onClose}>
                                            Close
                                        </Button>
                                        <Button type={'submit'} isLoading={isSubmiting}>Submit</Button>
                                    </ModalFooter>
                                </Form>
                            )
                        }
                    </Formik>
            </ModalContent>
        </Modal>
    );
};

export default AddLessonGroupDialog;
